/*
 * @description:
 * @author: wolfgun
 * @Date: 2021-02-28 16:11:13
 */
export const STATUS = [
  { showName: '成功', dictionaryId: 0 },
  { showName: '爽约', dictionaryId: 1 }
]
